import React, { FC, memo } from 'react';
import moment from 'moment';

interface DateTimeFormatProps {
  date: string;
  format?: string;
  localDate?: boolean;
}

const DateTimeFormatComponent: FC<DateTimeFormatProps> = ({
  date,
  format = 'MMMM DD, YYYY hh:mm A',
  localDate = false,
}) => {
  const momentDate = moment(date);

  if (!momentDate.isValid()) {
    return <>*Wrong date or format*</>;
  }

  if (localDate) {
    return <>{momentDate.local().format(format)}</>;
  }

  return <>{momentDate.format(format)}</>;
};

export const DateTimeFormat = memo(DateTimeFormatComponent);
